<template>
  <div>
    <default-card>
      <template slot="title-card"> </template>
      <template slot="title-left"> Equipe 👯 </template>
      <template slot="title-right"> 
        <v-btn color="black" text small dense class="mr-3 title-financial btn-primary"
          @click="$router.push({name: 'NewMember'})">
          <v-icon class="mr-1" size="26" color="black" small>mdi-plus-circle-outline</v-icon> 
          NOVO MEMBRO
        </v-btn>
      </template>
      <template slot="content">
        
        <v-col cols="12" lg="12">
          <index-company-members ref="IndexCompanyMembers" />
        </v-col>

        <v-col cols="12" lg="12">
          <v-card outlined style='border-radius: 5px' v-if="!loading_form && $route.name == 'MyCompanyMemberList'">
            <v-card-text><span  class="grey--text title">Selecione um membro para ver detalhes e edição.</span></v-card-text>
          </v-card>
          <v-card outlined style='border-radius: 5px' class="mt-5" v-if="loading_form">
            <card-loading-transparent loadingText="Carregando" />
          </v-card>
          <div v-if="!loading_form">
            <router-view ></router-view>
          </div>
        </v-col>

      </template>
    </default-card>
  </div>
</template>

<script>
  export default {
    name: 'MemberList',

    data() {
      return {
        loading_form: false,
      }
    },

    components: {
      IndexCompanyMembers: () => import ('./members/IndexCompanyMembers.vue'),
      EditMemberRole: () => import ('./members/EditMemberRole.vue'),
    },

    methods: {
      getData(){
        this.$refs.IndexCompanyMembers.getCompanyUsers()
      },
    },

    watch: {
      '$route.path'() {
        this.loading_form = true
        setTimeout(() => {
          this.loading_form = false
        }, 400);
        if(this.$route.params.any_member_updated){
          this.getData();
        }
      },
    },

  }
</script>

<style lang="scss" scoped>

</style>